import PropTypes from "prop-types";
import React, { useState } from "react";
import NipInput from "../../../NipInput/NipInput";
import { Form, Formik, Field } from "formik";
import Button from "../../../Button/Button";
import UploadDocs from "./UploadDocs";
import Storage from "../../../../utils/storage";
import { TestDataSchema } from "../../../../utils/validation";

const TestData = (props) => {
  const {
    selection,
    isSubmitting,
    submitSuccess,
    submitValues,
    getAllApplications,
    documents,
  } = props;

  const [state, setState] = useState({
    showTestData: true,
  });

  const handleSubmit = (values) => {
    handleFunc(values, setState, state);
  };

  return (
    <div>
      {state.showTestData ? (
        <div className="inward-test-data">
          <div className="nip-integration-header">
            Provide test data entries
          </div>
          <Formik
            initialValues={{
              accountNumber: "",
              wsdl_url: "",
            }}
            validationSchema={TestDataSchema}
            onSubmit={handleSubmit}
          >
            {({ values, isValid, dirty }) => {
              const block =
                values.accountNumber === "" || values.wsdl_url === "";
              return (
                <Form id="form">
                  <div className="inward-test-data-box">
                    <div className="inward-test-data-box-header">
                      Account Details
                    </div>
                    <div className="inward-test-data-box-input">
                      <Field
                        name="accountNumber"
                        label="Please provide test account number"
                        placeholder="Enter account number"
                        component={NipInput}
                      />
                    </div>
                  </div>

                  <div className="inward-test-data-box">
                    <div className="inward-test-data-box-header">Wsdl URL</div>
                    <div className="inward-test-data-box-input">
                      <Field
                        name="wsdl_url"
                        label="Please provide wsdl url"
                        placeholder="Enter wsdl url"
                        component={NipInput}
                      />
                    </div>
                  </div>
                  <div className="inward-test-data-button">
                    <Button
                      type="submit"
                      width="50%"
                      height="50px"
                      text="NEXT"
                      testId="handleSubmit"
                      disabled={block || !(isValid && dirty)}
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      ) : (
        <UploadDocs
          success={submitSuccess}
          documents={documents}
          submitValues={submitValues}
          selection={selection}
          isSubmitting={isSubmitting}
          acctNumber={Storage.get("account-number")}
          wsdlUrl={Storage.get("wsdl-url")}
          getAllApplications={getAllApplications}
        />
      )}
    </div>
  );
};
TestData.propTypes = {
  documents: PropTypes.array,
  getAllApplications: PropTypes.any,
  isSubmitting: PropTypes.any,
  selection: PropTypes.any,
  submitSuccess: PropTypes.any,
  submitValues: PropTypes.any,
};

export default TestData;

export const handleFunc = (values, setState, state) => {
  Storage.set("account-number", values.accountNumber);
  Storage.set("wsdl-url", values.wsdl_url);
  setState({
    ...state,
    showTestData: false,
  });
  return "success";
};
